import api from "./api";

const BASE_URL = "permissions/";

/* PERMISSIONS */
export const getPermissions = async (params = {}) => {
  const res = await api.get(`${BASE_URL}permissions/`, { params });
  const data = res.data.data || res.data;
  return Array.isArray(data) ? data : (data.results || []);
};

export const getGroupedPermissions = async () => {
  const res = await api.get(`${BASE_URL}permissions/grouped/`);
  return res.data.data || res.data;
};

/* ROLES */
export const getRoles = async (params = {}) => {
  const res = await api.get(`${BASE_URL}roles/`, { params });
  const data = res.data.data || res.data;
  return Array.isArray(data) ? data : (data.results || []);
};

export const getRoleDetail = async (roleId) => {
  const res = await api.get(`${BASE_URL}roles/${roleId}/`);
  return res.data.data || res.data;
};

export const createRole = async (data) => {
  const res = await api.post(`${BASE_URL}roles/`, data);
  return res.data.data || res.data;
};

export const updateRole = async (roleId, data) => {
  const res = await api.put(`${BASE_URL}roles/${roleId}/`, data);
  return res.data.data || res.data;
};

export const deleteRole = async (roleId, password) => {
  const headers = password ? { "X-Confirm-Password": password } : {};
  const res = await api.delete(`${BASE_URL}roles/${roleId}/`, { headers, data: { password }, params: { password } });
  return res.data;
};

/* ROLE PERMISSION MATRIX */
export const getRoleMatrix = async (roleId) => {
  const res = await api.get(`${BASE_URL}roles/${roleId}/matrix/`);
  return res.data.data || res.data;
};

export const updateRoleMatrix = async (roleId, permissionIds) => {
  const res = await api.put(`${BASE_URL}roles/${roleId}/matrix/`, { permission_ids: permissionIds });
  return res.data;
};

/* ROLE SPECIAL ACTIONS */
export const cloneRole = async (roleId, newName, newDescription = "") => {
  const res = await api.post(`${BASE_URL}roles/${roleId}/clone/`, {
    new_name: newName,
    new_description: newDescription,
  });
  return res.data.data || res.data;
};

export const toggleRoleStatus = async (roleId, isActive) => {
  const res = await api.post(`${BASE_URL}roles/${roleId}/toggle-status/`, { is_active: isActive });
  return res.data.data || res.data;
};

export const getRoleUsers = async (roleId) => {
  const res = await api.get(`${BASE_URL}roles/${roleId}/users/`);
  const data = res.data.data || res.data;
  return Array.isArray(data) ? data : (data.results || []);
};

/* USER ROLE ASSIGNMENTS */
export const assignUserRoles = async (userId, roleIds) => {
  const res = await api.post(`${BASE_URL}user-roles/assign/`, {
    user_id: userId,
    role_ids: roleIds,
  });
  return res.data;
};

export const removeUserRole = async (userId, roleId) => {
  const res = await api.post(`${BASE_URL}user-roles/remove/`, {
    user_id: userId,
    role_id: roleId,
  });
  return res.data;
};

/* AUDIT LOGS */
export const getRBACAuditLogs = async (params = {}) => {
  const res = await api.get(`${BASE_URL}audit-logs/`, { params });
  const data = res.data.data || res.data;
  return Array.isArray(data) ? data : (data.results || []);
};

/* EFFECTIVE PERMISSIONS */
export const getEffectivePermissions = async (userId = null) => {
  const params = userId ? { user_id: userId } : {};
  const res = await api.get(`${BASE_URL}effective-permissions/`, { params });
  return res.data.data || res.data;
};
